// extracted by mini-css-extract-plugin
export default {"container":"Header_container__Pv0TG","userSection":"Header_userSection__Q7ubz","notification":"Header_notification__PMMtM","menu":"Header_menu__ufnX5"};